export default __webpack_public_path__ + "static/tab-img12-eace9e7cfb34aabad317801407a5deb4.png";